/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".portal-header[_ngcontent-%COMP%]{height:70px;line-height:70px;background:#f8f8f8;display:flex;align-items:center;justify-content:flex-start;padding:0 60px}.header-item[_ngcontent-%COMP%]{flex:1}.title[_ngcontent-%COMP%]{font-size:26px;color:#777;text-align:center}img[_ngcontent-%COMP%]{height:33px;vertical-align:middle}@media screen and (max-width:700px){.header-item.title[_ngcontent-%COMP%]{display:none}}"];
export { styles as styles };
